'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ResponseHeader = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _isObject = require('d2-utilizr/lib/isObject');

var _isObject2 = _interopRequireDefault(_isObject);

var _isNumeric = require('d2-utilizr/lib/isNumeric');

var _isNumeric2 = _interopRequireDefault(_isNumeric);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ResponseHeader = exports.ResponseHeader = undefined;

exports.ResponseHeader = ResponseHeader = function ResponseHeader(refs, config, extraConfig) {
    var t = this;

    t.isPrefix = false;
    t.isCollect = false;
    t.index;

    config = (0, _isObject2.default)(config) ? config : {};

    // constructor
    _extends(t, config, extraConfig);
};

ResponseHeader.prototype.setIndex = function (index) {
    if ((0, _isNumeric2.default)(index)) {
        this.index = parseInt(index);
    }
};

ResponseHeader.prototype.getIndex = function (index) {
    return this.index;
};
//# sourceMappingURL=ResponseHeader.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/api/ResponseHeader.js
 ** module id = 126
 ** module chunks = 0 1
 **/